module.exports = __webpack_public_path__ + "static/media/search.4c034752.svg";